<div class="note-container" [ngClass]="{'container-empty': noDataStyle === 'flex'&&windowSize<695}">
    <div class="body-header">
        <div class="title body-header-title">Notes</div>
        <div class="body-header-icon">
            <smart-icon class="angle-icon" name="meatball" (click)="onMeatball($event,$event)"></smart-icon>
        </div>
    </div>
    <div class="body-container">
        <div class="no-data" [style.display]="noDataStyle">
            <span>No Data</span>
        </div>
        <div class="item-note body-1 item-note-value">{{config.data}}</div>
    </div>
    <context-menu #contextItemMenu>
        <ng-template contextMenuItem let-item (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Activities</span>
            </div>
        </ng-template>
        <ng-template contextMenuItem let-item (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Relationships</span>
            </div>
        </ng-template>

        <ng-template contextMenuItem let-item [subMenu]="screenSubMenu">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Contact Profile</span>
            </div>
            <smart-icon name="angle-right" class="angle-right">
            </smart-icon>
        </ng-template>
        <context-menu #screenSubMenu>
            <ng-template contextMenuItem *ngFor="let subMenu of contextMenu;trackBy:trackByFn"
                (execute)="onMenuSelect($event)">
                <div class="screen-sub-menu-container">
                    <span>{{subMenu.title}}</span>
                </div>
            </ng-template>
        </context-menu>

        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && !isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Collapse Tile</span>
            </div>
        </ng-template>
        <ng-template *ngIf="config.position !== 2 && config.position !== 4 && isCollapse" contextMenuItem let-item
            (execute)="onMenuSelect($event)">
            <div class="screen-menu-item-container">
                <span class="context-menu-title">Expand Tile</span>
            </div>
        </ng-template>
    </context-menu>
</div>